import React from 'react';
import P from '../images/messages.png'
import T from '../pages/ListDam.module.css'
import PersonIcon from '@mui/icons-material/Person';
import { Link, useNavigate } from 'react-router-dom'
import E from '../images/farmic.jpg'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import HomeIcon from '@mui/icons-material/Home';
import S from './AllFarmsAdmin.module.css'
import InfoIcon from '@mui/icons-material/Info';
import D from '../images/user.png'
import { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useGlobalContext } from '../Components/Context'
import { TicketList, addDetailStatusList, logOut, loginSuccess } from '../redux/slices/adminSlice'
import AddMarker from '../Components/Mapp';
import CreateNewFarm from '../Components/createNewFramModal';
import { logOutF, loginSuccessF } from '../redux/slices/farmsSlice';
import { logOutS, loginSuccessS } from '../redux/slices/singleFarmSlice';

import apiService from '../api/ApiService';
import { Col, Container, Row } from 'react-bootstrap';
import WarningStatus from '../Components/WarningStatus';
import { DateRangeOutlined, EmailOutlined, ExitToAppRounded, MessageOutlined, Settings, TitleSharp } from '@mui/icons-material';
import TicketNEw from '../Components/ViewTicketModal';
import { logOutPP } from '../redux/slices/PensStatusSlice';
import { logOutA } from '../redux/slices/superAdminSlice';
import { deleteAllSensors } from '../redux/slices/allSensorSlice';
import { deleteAllCollectors } from '../redux/slices/collectorsSlice';
import { deleteAllComments } from '../redux/slices/commentsSlice';
import { logOutP } from '../redux/slices/pensSlice';
import { deleteSensor } from '../redux/slices/singleSensorSlice';
import { logOutL } from '../redux/slices/listDamSlice';
import { logOutC } from '../redux/slices/singleCattleSlice';
import { deleteAllCol } from '../redux/slices/singleCollectorSlice';
import { deleteWarn } from '../redux/slices/warningSlice';
import { deleteTime } from '../redux/slices/timeSlice';
import EmptyReturn from '../Components/EmptyReturn';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { Box, Tab } from '@mui/material';
import CollectorsComp from '../Components/DeviceList/CollectorList';
import TerminalsComp from '../Components/DeviceList/TerminalList';
import SensorListComp from '../Components/DeviceList/SensorList';
import SwitchComponent from '../Components/SwitchComponent';
import Admins from '../Components/DeviceList/AdminList';
const moment=require('moment-jalaali')

 

const AllFarmsAdmin=()=>{
  const {tickets}=useSelector(state=>state.p.admin)
  const [tick,setTick]=useState({})
  const [value,setValue]=useState('1')
  const {currentFarms}=useSelector(state=>state.farms);
  const {openModalls,isOpenModal,isModalWarnOPen,openWarn,openDeleteModal,isDeleteModalOpen}=useGlobalContext();
const [check,setCheck]=useState(false)
const [sOwner,setSOwner]=useState('');
  const [selected,setSelected]=useState({})
  const [data2,setData2]=useState([])
const dispatch=useDispatch()
const navigate=useNavigate()
const handleLogout=()=>{
  dispatch(logOutPP())
  dispatch(logOut())
  dispatch(logOutA())
  dispatch(deleteAllSensors())
  dispatch(deleteAllCollectors())
  dispatch(deleteAllComments())
  dispatch(logOutF())
  dispatch(logOutP())
  dispatch(logOutS())
  dispatch(deleteSensor())
  dispatch(logOutL())
  dispatch(logOutF())
  dispatch(logOutC())
  dispatch(deleteAllCol())
  dispatch(deleteWarn())
  dispatch(deleteTime())
  navigate('/')
}   
const gett=async()=>{
  const res3=await apiService.getDetailsCattleStatus()
  dispatch(addDetailStatusList(res3.data?.data))
}
    const getData=async()=>{
      const data=JSON.stringify({
        "skip": 0,
        "take": 0,
        "fromDate": "2023-12-17T13:00:31.937Z",
        "toDate": "2023-12-17T13:00:31.937Z"
      })
        const res=await apiService.getFarmsList(data)
        dispatch(loginSuccessF(res.data.data))
        setData2(()=>currentFarms)
    }
    const getTickets=async()=>{
      const data=JSON.stringify({
        "skip": -1,
        "take": -1,
        "fromDate": null,
        "toDate":null,
        "title": null,
        "farmId": null,
        "createUserId": null,
        "responseUserId": null,
        "ticketStatus": 1,
        "fromResponseDate": null,
        "toResponseDate": null
      })
     
      const res=await apiService.getTickets(data)
      dispatch(TicketList(res.data.data))
    }
    useEffect(()=>{
      
        getData()
        getTickets()
        gett()
    },[]);

    const handleSearch=()=>{
      if(!sOwner){
          setData2(currentFarms)
      }else{
        const newData=currentFarms.filter(item=>{
         
         
          return item.ownerName.includes(sOwner)
        
      })
      setData2(newData)
      }
      
       
      
    }
    useEffect(()=>{
        handleSearch()
    },[sOwner])
    useEffect(()=>{
      handleSearch()
    },[currentFarms]);
    // useEffect(()=>{
    //   dispatch(successLogSens([]))

    // },[currentSfarm])
    
   

const handleSelected=(item)=>{
        setSelected(item)
    }
const handleChange = (event, newValue) => {
      setValue(newValue);
    };
    useEffect(()=>{
     if(check){
        dispatch(loginSuccess(selected))
        dispatch(loginSuccessS(selected))
        navigate('/Dashboard')
     }else{
        setCheck(true)
     }
    },[selected])
    return <div style={{position:'relative'}}>
            <div className={S.headerCont}>
                <div className={S.AdminName}>
                    <img src={D}/>
                    <span>{`ادمین`}</span>
                    <div className='logOutContainer' data-title='خروج' onClick={handleLogout}>  <ExitToAppRounded fontSize='large'/></div>
                    <div data-title='تغییر نحوه ی نمایش لیست ها' className={`switchBttn ${S.StatusCons} `}>
            <SwitchComponent/>
            </div>
                </div>
                <div className={S.searchCon}>
            
        
            </div>
                <div onClick={()=>openModalls()} data-title='افزودن دامداری جدید' className={`${S.CreateNewFarmBtn}`}>
                <AddCircleOutlineIcon sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
            </div>
            
            </div>
            
            
            <hr className={S.hr}/>
            <Container>
              <Row>
                <Col sm="12" lg="6">
                <div className={S.MappCon}>
                {currentFarms.length&&<AddMarker data={currentFarms}  selected={selected}/>}
            </div></Col>
            <Col sm="12" lg="6">
            <div className={S.TicketCon}>
            <div className={T.AllAnimalssTitleLICon}>
        <img className={T.AllAnimalssIconimgLITit2} src={P}/>
        <h4> تیکت های جدید</h4>
        </div>
                <div className={S.TicketList} style={{color:'black',width:'100%',display:'flex',gap:'10px',flexWrap:'wrap'}}>
            {tickets?.length?tickets.map((item,index)=>{
                const {createDate}=item;
                const birth=createDate?.substring(0,19);
                const pbirth=moment(birth).format('jYYYY-jMM-jDD HH:mm')
                return <div key={index} onClick={()=>{openDeleteModal();setTick(item)}} className=" viewTicketAll">
                                    <div className="dateOfTicket"><DateRangeOutlined/>{pbirth}</div>

                <div style={{display:'flex',gap:'3px',alignItems:'center',fontSize:'15px'}}><TitleSharp style={{color:'#078d0e'}}/> عنوان : {item?.title}</div>
            </div>
            }):<EmptyReturn w='200' h='200'/>}
            </div>
            </div>
            </Col>
              </Row>
            </Container>
            
            <TabContext  value={value}>
  <Box  style={{direction:'rtl',marginTop:'30px',marginRight:'10px',padding:'0px 8px'}}>
    <TabList variant="scrollable" scrollButtons="auto"  onChange={handleChange} aria-label="lab API tabs example">
      <Tab label="دامداری ها" value="1" />
      <Tab label="کالکتور ها" value="2" />
      <Tab label="ترمینال ها" value="3" />
      <Tab label="سنسور ها" value="4" />
      <Tab label="ادمین ها" value="5" />
    </TabList>
  </Box>
  <hr style={{marginTop:'-3px'}}/>
  <TabPanel value="1">
  <Container dir='rtl'>
              <Row>
                <Col sm='12' lg='12'>
                <div className='d-flex justify-content-center  flex-wrap m-auto align-item-center' style={{direction:'rtl',gap:'20px'}}>
            {
               currentFarms?.length&&currentFarms.map((item,index)=>{
                    
                return <Link onClick={()=>handleSelected(item)}>
                      <div className={S.farmCard} key={index}>
                      
                      <img src={E} className={S.ImgCard}/>
                    
                  <div style={{margin:'10px',fontSize:'13px',display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                  <div  style={{fontWeight:'bold'}}>
                    
                    {item?.name}
                  </div>
                  
                    <div>
                      مالک : {item?.ownerName}
                    </div>
                    
                  
                  <div style={{width:'180px'}}>
                  <div style={{whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
                    آدرس : {item?.address?.substring(0,45)}
                  </div>
                  </div>
                  </div>
            </div>
          
                </Link>
              })
            }
            </div>
                </Col>
               
              </Row>
              
            </Container>
  </TabPanel>
  <TabPanel value="2">
    <CollectorsComp/>
  </TabPanel>
  <TabPanel value="3">
    <TerminalsComp/>
  </TabPanel>
  <TabPanel value="4">
    <SensorListComp Value={0}/>
  </TabPanel>
  <TabPanel value="5">
    <Admins/>
  </TabPanel>
</TabContext>
            
          {/* </div> */}
            {isOpenModal&&<CreateNewFarm/>}
            
            {isDeleteModalOpen&&<TicketNEw data={tick} flag={1}/>}
            <Link to='/AllFarmsAdmin/mainSettings' className='btnAllLiveStock'>
                    تنظیمات <Settings/>
            </Link>
    </div>
}
export default AllFarmsAdmin